import React from 'react';

const Loading = () => {
  return ( <div id="loading"> 
     <h2 className="message">Searching...</h2>
   </div>
   )
 }

 export default Loading;